import { render, staticRenderFns } from "./ApplicationMessageComponent.vue?vue&type=template&id=caa6539a&scoped=true&"
import script from "./ApplicationMessageComponent.vue?vue&type=script&lang=ts&"
export * from "./ApplicationMessageComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationMessageComponent.vue?vue&type=style&index=0&id=caa6539a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa6539a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VAlert,VFlex,VLayout})
